import { render } from "./TranslationModal.vue?vue&type=template&id=550cd5ef"
import script from "./TranslationModal.vue?vue&type=script&lang=js"
export * from "./TranslationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__